(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initCart(scope = document) {
    const cart = scope.matches?.('[data-nd-cart]') ? scope : scope.querySelector('[data-nd-cart]');
    const form = cart?.querySelector('form');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const updateButton = form.querySelector('[name="update"]');
    const status = form.querySelector('[data-nd-cart-status]');
    let busy = false;
    let nativeFallback = false;
    form.querySelectorAll('[data-nd-quantity]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        const next = Number(input.value) + Number(button.dataset.ndQuantity) * Number(input.step || 1);
        input.value = String(Math.max(0, next));
        form.requestSubmit(updateButton);
      });
    });
    updateButton.hidden = true;
    form.querySelectorAll('input[name="updates[]"]').forEach(input => {
      input.addEventListener('change', () => form.requestSubmit(updateButton));
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); form.requestSubmit(updateButton); }
      });
    });
    form.addEventListener('submit', async event => {
      if (nativeFallback) return;
      if (busy) { event.preventDefault(); return; }
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      const body = new FormData(form);
      body.set('update', '1');
      const focused = document.activeElement;
      const focusedInput = focused?.closest('.nd-classic-cart__quantity')?.querySelector('input');
      const focusId = focusedInput?.id;
      const focusStep = focused?.dataset?.ndQuantity;
      busy = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.updating;
      const controls = [...form.querySelectorAll('button,input')];
      controls.forEach(control => { control.disabled = true; });
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(form.action, {method:'POST', body, credentials:'same-origin', signal:controller.signal});
        if (!response.ok) throw new Error('Cart update failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = page.querySelector('[data-nd-cart]');
        if (!replacement) throw new Error('Cart missing');
        const count = page.querySelector('.nd-cart-link span');
        if (count) document.querySelectorAll('.nd-cart-link span').forEach(node => { node.textContent = count.textContent; });
        cart.replaceWith(replacement);
        initCart(replacement);
        if (focusId) {
          const input = replacement.querySelector('#' + focusId);
          const target = focusStep ? input?.parentElement.querySelector('[data-nd-quantity="' + focusStep + '"]') : input;
          target?.focus({preventScroll:true});
        }
      } catch {
        controls.forEach(control => { control.disabled = false; });
        nativeFallback = true;
        form.requestSubmit(updateButton);
      } finally {
        clearTimeout(timeout);
      }
    });
  }
  initCart();
  document.addEventListener('shopify:section:load', event => initCart(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
